import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "w",
  class: "dateonlypicker-container"
}
const _hoisted_2 = { class: "picker" }
const _hoisted_3 = {
  key: 0,
  class: "button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_date_picker, {
        ref: "dp",
        modelValue: _ctx.userDateModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userDateModel) = $event)),
        type: "date",
        placeholder: "",
        size: _ctx.size,
        clearable: true,
        format: "DD.MM.YYYY",
        "value-format": "YYYY-MM-DD",
        onChange: _ctx.onDatePicked
      }, null, 8, ["modelValue", "size", "onChange"])
    ]),
    (_ctx.clearable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_link, {
            underline: false,
            icon: _ctx.cancelIcon,
            onClick: _ctx.onCancelClick
          }, null, 8, ["icon", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}